import { guides } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
          <SectionHeading
            eyebrow="WATCHING GUIDE"
            title="追剧指南：把时间花在真正想看的片上"
            desc="片库越大，越需要一点方法。下面这几条是我们整理的观影与追剧建议，从挑片、筛选到安排节奏，帮你在有限的空闲里看得更舒服。"
          />

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {guides.map((item, index) => (
              <article
                key={item.id}
                className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="font-heading text-2xl font-black text-background-300">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}